export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      lastName: '',
      username: '',
      email: '',
      password: 'driverCheck123', // so it isnt empty
      userId: null,
      loginCode: ''
    }
  }
}